const useHomepage = () => ({});

export default useHomepage;
